/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Actions_RemoveInputs */

const es_admin_users_actions_remove = /** @type {(inputs: Admin_Users_Actions_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Usuario`)
};

const en_admin_users_actions_remove = /** @type {(inputs: Admin_Users_Actions_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete User`)
};

/**
* | output |
* | --- |
* | "Delete User" |
*
* @param {Admin_Users_Actions_RemoveInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_actions_remove = /** @type {((inputs?: Admin_Users_Actions_RemoveInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Actions_RemoveInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_actions_remove(inputs)
	return en_admin_users_actions_remove(inputs)
});
export { admin_users_actions_remove as "admin.users.actions.remove" }